export default __webpack_public_path__ + "static/media/goldLeaderBoardStar.5036c249.svg";